<span title="{{ currentAppVersionFull }}">
    v{{ currentAppVersion }}
</span>
